// extracted by mini-css-extract-plugin
export default {"depositList":"Deposit_depositList__0KPSw","statisticDeposit":"Deposit_statisticDeposit__2sn2j"};